import { Component, Input } from '@angular/core';
import { EMPTY_STRING, ICON_URLS } from '@app/constants';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  @Input() primaryText = EMPTY_STRING;
  @Input() secondaryText = EMPTY_STRING;
  iconExclaim = ICON_URLS.IconExclaim;
}
